import activityLogRoutes from 'modules/activityLog/common/routing/routes'

const routes = {
  root: `${activityLogRoutes.root}/details/onboard-assessment`,
}

export default routes
